export default {
    icon: "el-icon-shopping-bag-2",
    title: "拼团",
    name: "combination",
    timestamp: "1709627778508007",
    setUp: {
        tabVal: 1
    },
    numConfig: {
        val: 3
    },
    priceShow: {
        title: "是否显示价格",
        val: true
    },
    bntShow: {
        title: "是否显示按钮",
        val: true
    },
    titleShow: {
        title: "是否显示名称",
        val: true
    },
    pinkShow: {
        title: "是否显示拼团标签",
        val: true
    },
    joinShow: {
        title: "是否显示参团标签",
        val: 1
    },
    txtColor: {
        title: "文字背景色",
        name: "themeColor",
        default: [
            {
                item: "rgba(255,68,68,0.1)"
            }
        ],
        color: [
            {
                item: "rgba(252, 60, 62, 1)"
            }
        ]
    },
    conStyle: {
        title: "背景样式",
        name: "conStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: 'el-icon-edit-outline'
            },
            {
                val: "圆角",
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    bgColor: {
        title: "背景颜色",
        name: "themeColor",
        default: [
            {
                item: "#fff"
            }
        ],
        color: [
            {
                item: "#fff"
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 10,
        min: 0
    },
    themeColor: {
        title: "主题风格",
        name: "themeColor",
        default: [
            {
                item: "#E93323"
            }
        ],
        color: [
            {
                item: "#E93323"
            }
        ]
    },
    mbConfig: {
        title: "页面间距",
        val: 10,
        min: 0
    },
    lrConfig: {
        title: "左右边距",
        val: 10,
        min: 0
    },
    imgConfig: {
        title: "最多可添加1张图片，建议宽度18 * 18px",
        url: ""
    },
    id: "id1709627778508007"
}